<div class="page-container">
  <img class="logo" src="assets/images/sparkly_logo.png" alt="Logo">

  <ng-container *ngIf="!emailSent">
    <div class="header">
      <h2 translate>forgot_password.title</h2>
      <p translate>forgot_password.message</p>
    </div>
    <form>
      <app-text-input [control]="getControl('email')" [(value)]="emailAddress" [label]="'login.email' | translate" [placeholder]="'login.email_placeholder' | translate"></app-text-input>
      <div class="buttons-container">
        <app-button [text]="'forgot_password.reset_password' | translate" [type]="'submit'" [loading]="isLoading" (clickEvent)="sendLink()"></app-button>
        <app-button [text]="'forgot_password.back_to_login' | translate" [leftIcon]="'fa-arrow-left'" [style]="'only-text'" (clickEvent)="backToLogin()"></app-button>
      </div>
    </form>
  </ng-container>
  
  <ng-container *ngIf="emailSent">
    <app-success-screen [title]="'forgot_password.success_title' | translate" [message]="'forgot_password.success_message' | translate: {email: form.value.email}" [buttonText]="'forgot_password.back_to_login' | translate" (buttonClicked)="backToLogin()"></app-success-screen>
  </ng-container>
</div>